import {
  type HistoryData,
  type PoolAccount,
  AccountEventType,
  ReviewStatus,
} from './types';

const toNumericTimestamp = (timestamp?: bigint): number => {
  if (!timestamp || timestamp <= 0n) return 0;

  return Number(timestamp);
};

export const buildHistoryData = (
  poolAccountsByChainScope: Record<string, PoolAccount[]>,
): HistoryData => {
  const history: HistoryData = [];

  for (const accounts of Object.values(poolAccountsByChainScope)) {
    for (const poolAccount of accounts) {
      history.push({
        type: AccountEventType.DEPOSIT,
        txHash: poolAccount.deposit.txHash,
        reviewStatus: poolAccount.reviewStatus,
        amount: poolAccount.deposit.value,
        timestamp: toNumericTimestamp(poolAccount.deposit.timestamp),
        label: poolAccount.label,
        scope: poolAccount.scope,
        chainId: poolAccount.chainId,
      });

      for (const [index, child] of poolAccount.children.entries()) {
        const previousValue =
          index === 0
            ? poolAccount.deposit.value
            : poolAccount.children[index - 1]!.value;

        history.push({
          type: AccountEventType.WITHDRAWAL,
          txHash: child.txHash,
          reviewStatus: ReviewStatus.APPROVED,
          amount: previousValue - child.value,
          timestamp: toNumericTimestamp(child.timestamp),
          label: child.label,
          scope: poolAccount.scope,
          chainId: poolAccount.chainId,
        });
      }
    }

    for (const poolAccount of accounts) {
      if (!poolAccount.ragequit?.transactionHash) continue;

      history.push({
        type: AccountEventType.EXIT,
        txHash: poolAccount.ragequit.transactionHash,
        reviewStatus: ReviewStatus.APPROVED,
        amount: poolAccount.ragequit.value,
        timestamp: toNumericTimestamp(poolAccount.ragequit.timestamp),
        label: poolAccount.ragequit.label,
        scope: poolAccount.scope,
        chainId: poolAccount.chainId,
      });
    }
  }

  return history.sort((left, right) => right.timestamp - left.timestamp);
};
